import React, { useState } from 'react';
import {
  Descriptions,
  Table,
  Modal,
  Button,
  Result,
  Spin,
  Space,
  Row,
  Col,
  Image,
  Tag,
} from 'antd';
import get from 'lodash/get';
import omit from 'lodash/omit';
import map from 'lodash/map';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowLeftOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { OFFERINGS } from '../../../constants/routes';
import { productSelectionColumns } from '../../../constants/catalogue';
import { offeringManagement } from '../../../redux/actions/offeringAction';

const OfferingFinalDetails = ({ details, onMove, edit, id, companyId }) => {
  const [loading, setLoading] = useState(false);
  const role = useSelector((state) => get(state, 'auth.role'));

  const [videoPreview, setVideoPreview] = useState({
    visible: false,
    filePath: null,
  });

  const dispatch = useDispatch();

  const history = useHistory();

  const onClickGoToOffering = () => {
    history.replace(OFFERINGS);
  };

  const [successModal, setSuccessModal] = useState({
    visible: false,
    sku: null,
  });

  const toggleVideoPreview = (filePath = null) => {
    setVideoPreview({
      visible: !get(videoPreview, 'visible'),
      filePath,
    });
  };

  const onCreateProductOffering = (payload) => {
    setLoading(true);
    dispatch(offeringManagement('create.offering', payload))
      .then((result) => {
        setLoading(false);
        setSuccessModal({
          visible: true,
          data: get(result, 'data'),
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onEditProductOffering = (payload) => {
    setLoading(true);
    dispatch(offeringManagement('update.offering', payload))
      .then((result) => {
        setLoading(false);
        setSuccessModal({
          visible: true,
          data: get(result, 'data'),
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const onSubmit = () => {
    const payload = {
      is_active: true,
      company_id: edit
        ? parseInt(companyId)
        : map(get(details, 'step2', []), (pro) => get(pro, 'Company.id'))[0],
      sales_channel_id: get(details, 'step1.id'),
      name: get(details, 'step3.name'),
      mrp: get(details, 'step3.mrp'),
      availability: get(details, 'step3.availability'),
      partner_retailer: get(details, 'step3.partner_retailer'),
      discount_percent: get(details, 'step3.discount_percent')
        ? get(details, 'step3.discount_percent')
        : 0,
      other_info: get(details, 'step4.other_info'),
      connection_id: get(details, 'step1.Connection.id'),
      item_count: get(details, 'step3.item_count'),
      offering_media: get(details, 'step3.media', []),
      product: map(get(details, 'step2', []), (pro) => ({
        id: get(pro, 'id'),
        item_count: get(pro, 'quantity'),
      })),
    };
    omit(payload, ['meta']);

    if (edit) {
      onEditProductOffering({ id: parseInt(id), ...payload });
    } else {
      onCreateProductOffering(payload);
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="product-final-confirmation-container">
        <p className="normal-heading ">Sales Channel </p>
        <div className="product-description-container">
          <Descriptions bordered column={2} size="small">
            <Descriptions.Item label="Channel">
              <Space size="large">
                <Image
                  src={get(details, 'step1.image')}
                  width={50}
                  height={50}
                />
                {get(details, 'step1.name')}
              </Space>
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div className="mt-40">
          <p className="normal-heading ">Products</p>
        </div>
        <div className="product-description-container ">
          <Table
            dataSource={get(details, 'step2', [])}
            columns={productSelectionColumns(false, get(role, 'role_code'))}
            pagination={false}
          />
        </div>

        <div className="mt-40">
          <p className="normal-heading ">Offering Details</p>
        </div>
        <div className="product-description-container ">
          <Descriptions bordered column={4} layout="vertical" size="small">
            <Descriptions.Item label="Offering Name">
              {get(details, 'step3.name')}
            </Descriptions.Item>
            <Descriptions.Item label="MRP">
              {get(details, 'step3.mrp')}
            </Descriptions.Item>
            <Descriptions.Item label="Number of Items">
              {get(details, 'step3.item_count')}
            </Descriptions.Item>
            <Descriptions.Item label="Discount (%)">
              {get(details, 'step3.discount_percent')}
            </Descriptions.Item>
            <Descriptions.Item label="Availability">
              {get(details, 'step3.availability') === 'SELECTIVE'
                ? 'Selective'
                : 'Public'}
            </Descriptions.Item>
            {get(details, 'step3.availability') === 'SELECTIVE' && (
              <Descriptions.Item label="Retailers">
                {map(
                  get(details, 'step3.partnerRetailers', []),
                  (retailer, i) => (
                    <Tag key={i}>{get(retailer, 'name')}</Tag>
                  )
                )}
              </Descriptions.Item>
            )}
          </Descriptions>
        </div>

        {get(details, 'step3.media', []).length > 0 && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Media </p>
            </div>
            <div className="media-section">
              {map(get(details, 'step3.media'), (m, index) => {
                if (get(m, 'type') === 1) {
                  return (
                    <Image
                      key={index}
                      src={get(m, 'file_path')}
                      className="img-upload-btn"
                      style={{
                        border: ' 1px dashed #d9d9d9',
                      }}
                    />
                  );
                }

                return (
                  <div className="img-upload-btn">
                    <PlayCircleOutlined
                      className="table-icon"
                      onClick={() => {
                        toggleVideoPreview(get(m, 'file_path'));
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}

        {get(details, 'step4.other_info') && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Other Necessary Information </p>
            </div>
            <div className="product-description-container ">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item>
                  {get(details, 'step4.other_info')}
                </Descriptions.Item>
              </Descriptions>
            </div>
          </>
        )}

        <Row justify="center" className="mt-60">
          <Col xl={8}>
            <Button
              className="default-primary-btn"
              type="primary"
              icon={<ArrowLeftOutlined />}
              onClick={() => onMove(3)}
            >
              Back
            </Button>
          </Col>
          <Col xl={8} />
          <Col xl={8}>
            <Button
              className="default-primary-btn"
              type="primary"
              block
              onClick={() => {
                onSubmit();
              }}
            >
              Save & Proceed
            </Button>
          </Col>
        </Row>

        <Modal
          width="50%"
          destroyOnClose
          open={get(videoPreview, 'visible')}
          onOk={toggleVideoPreview}
          onCancel={toggleVideoPreview}
          footer={null}
          className="video-preview-modal"
        >
          {get(videoPreview, 'filePath')}
          <video width="100%" height="300" controls>
            <source src={get(videoPreview, 'filePath')} type="video/mp4" />
            <track
              src="captions_en.vtt"
              kind="captions"
              srcLang="en"
              label="english_captions"
            />
          </video>
        </Modal>
        <Modal
          visible={get(successModal, 'visible')}
          footer={null}
          closable={false}
        >
          <Result
            status="success"
            title={
              edit
                ? 'Offering updated successfully'
                : 'Offering created successfully'
            }
            extra={[
              <Button
                className="default-primary-btn"
                type="primary"
                key="console"
                onClick={() => onClickGoToOffering()}
              >
                Back to Offerings
              </Button>,
            ]}
          />
        </Modal>
      </div>
    </Spin>
  );
};

export default OfferingFinalDetails;
